<template>
<div class="jumbotron">
  <div class="row">
    <h1 class="header-text">Legal Details</h1>
  </div>
  <div class="row mt-3">
    <p>Expiration date from date coupon is claimed:<span v-if="!expirationDate" class="red-text">*</span></p>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=2160 id="days_90" v-model="expirationDate" name="expirationDate" type="radio" v-bind:class="{'is_invalid': expirationDateInvalid}" required>
      <label for="days_90">90 days</label>
    </div>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=2880 id="days_120" v-model="expirationDate" name="expirationDate" type="radio" v-bind:class="{'is_invalid': expirationDateInvalid}" required>
      <label for="days_120">120 days</label>
      </div>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=4320 id="months_6" v-model="expirationDate" name="expirationDate" type="radio" v-bind:class="{'is_invalid': expirationDateInvalid}" required>
      <label for="months_6">6 months</label>
      </div>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=8760 id="years_1" v-model="expirationDate" name="expirationDate" type="radio" v-bind:class="{'is_invalid': expirationDateInvalid}" required>
      <label for="years_1">1 year</label>
    </div>
  </div>
  <div class="row mt-3">
    <p>Can this coupon be combined with another offer, certificate, or voucher?<span v-if="!combosAllowed" class="red-text">*</span></p>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=true id="combos_allowed" v-model="combosAllowed" name="combosAllowed" type="radio" v-bind:class="{'is_invalid': combosAllowedInvalid}" required>
      <label for="combos_allowed">Yes</label>
    </div>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=false id="combos_not_allowed" v-model="combosAllowed" name="combosAllowed" type="radio" v-bind:class="{'is_invalid': combosAllowedInvalid}" required>
      <label for="combos_not_allowed">No</label>
    </div>
  </div>
  <div class="row mt-3">
    <p>How many times can a customer/household use this coupon in a one year period?<span v-if="!customerReuses" class="red-text">*</span></p>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=1 id="no_reuses" v-model="customerReuses" name="reuses" type="radio" v-bind:class="{'is_invalid': customerReusesInvalid}" required>
      <label for="no_reuses">Once</label>
    </div>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=2 id="one_reuse" v-model="customerReuses" name="reuses" type="radio" v-bind:class="{'is_invalid': customerReusesInvalid}" required>
      <label for="one_reuse">Twice</label>
    </div>
  </div>
  <div class="row">
    <div class="col form-control">
      <input value=-1 id="unlimited_uses" v-model="customerReuses" name="reuses" type="radio" v-bind:class="{'is_invalid': customerReusesInvalid}" required>
      <label for="unlimited_uses">No limitation</label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-6">
      <router-link tag="button"
                   to="/profile/business/advertising/coupons/messages"
                   class="btn btn-secondary cover-open-space">Back</router-link>
    </div>
    <div class="col-6">
      <button v-on:click="validate" class="btn btn-primary">Review Coupon</button>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      // Form validation variables
      combosAllowedInvalid: false,
      customerReusesInvalid: false,
      expirationDateInvalid: false,
      formInvalid: false
    }
  },
  methods: {
    ...mapMutations('products', [
      'updateCouponExpiration',
      'updateCouponCombosAllowed',
      'updateCouponCustomerReuses'
    ]),
    validate () {
      this.formInvalid = false
      if (!this.combosAllowed) {
        this.combosAllowedInvalid = true
        this.formInvalid = true
      } else {
        this.combosAllowedInvalid = false
      }

      if (!this.customerReuses) {
        this.customerReusesInvalid = true
        this.formInvalid = true
      } else {
        this.customerReusesInvalid = false
      }

      if (!this.expirationDate) {
        this.expirationDateInvalid = true
        this.formInvalid = true
      } else {
        this.expirationDateInvalid = false
      }

      if (this.formInvalid) return

      this.$router.push('/profile/business/advertising/coupons/checkout')
    }
  },
  computed: {
    ...mapGetters('products', [
      'getCouponCategory',
      'getCouponExpiration',
      'getCouponCombosAllowed',
      'getCouponCustomerReuses'
    ]),
    category () {
      return this.getCouponCategory
    },
    combosAllowed: {
      get () {
        return this.getCouponCombosAllowed
      },
      set (value) {
        this.updateCouponCombosAllowed(value)
      }
    },
    customerReuses: {
      get () {
        return this.getCouponCustomerReuses
      },
      set (value) {
        this.updateCouponCustomerReuses(parseInt(value))
      }
    },
    expirationDate: {
      get () {
        return this.getCouponExpiration
      },
      set (value) {
        this.updateCouponExpiration(parseInt(value))
      }
    }
  }
}
</script>

<style scoped>
.cover-open-space {
  width: 100% !important;
}

.header-text {
  font-size: 2rem;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/coupons/subnavItems/Legal.vue